"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Globe = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "globe" },
            react_1.default.createElement("path", { id: "Icon", d: "M16 12L16.9998 12.0208C17.0001 12.0069 17.0001 11.9931 16.9998 11.9792L16 12ZM8 12L7.00022 11.9792C6.99993 11.9931 6.99993 12.0069 7.00022 12.0208L8 12ZM2 13H22V11H2V13ZM11.2617 2.67442C13.5995 5.2338 14.928 8.55521 15.0002 12.0208L16.9998 11.9792C16.9175 8.02885 15.4031 4.24291 12.7383 1.32558L11.2617 2.67442ZM15.0002 11.9792C14.928 15.4448 13.5995 18.7662 11.2617 21.3256L12.7383 22.6744C15.4031 19.7571 16.9175 15.9711 16.9998 12.0208L15.0002 11.9792ZM12.7383 21.3256C10.4005 18.7662 9.07198 15.4448 8.99978 11.9792L7.00022 12.0208C7.08251 15.9711 8.59689 19.7571 11.2617 22.6744L12.7383 21.3256ZM8.99978 12.0208C9.07198 8.55521 10.4005 5.2338 12.7383 2.67442L11.2617 1.32558C8.59689 4.24291 7.08251 8.02885 7.00022 11.9792L8.99978 12.0208ZM21 12C21 16.9706 16.9706 21 12 21V23C18.0751 23 23 18.0751 23 12H21ZM12 21C7.02944 21 3 16.9706 3 12H1C1 18.0751 5.92487 23 12 23V21ZM3 12C3 7.02944 7.02944 3 12 3V1C5.92487 1 1 5.92487 1 12H3ZM12 3C16.9706 3 21 7.02944 21 12H23C23 5.92487 18.0751 1 12 1V3Z" }))));
};
exports.default = Globe;
